import { Dispatch, SetStateAction, useCallback } from "react"
import { Grid } from "@mui/material"
import { ResourceFiltersTypes } from "../../../createOrderTypes"
import { ResourceFilterMenu } from "./ResourceFilterMenu"
import { FilterSearch } from "../../FilterSearch"
import { BookPeriodFilter } from "./BookPeriodFilter"
import { ViewType } from "../resourceBookingCalendars/BookingViewMenu"

type ResourceFiltersProps = Readonly<{
    filters: ResourceFiltersTypes
    setFilters: Dispatch<SetStateAction<ResourceFiltersTypes>>
    selectedView: ViewType
    isTimeline?: boolean
    userId: number
    isSpecialFlow: boolean
}>

export function ResourceFilters({
    filters,
    userId,
    setFilters,
    selectedView,
    isTimeline,
    isSpecialFlow,
}: ResourceFiltersProps) {
    const handleSearch = useCallback(
        (searchText: string) => {
            setFilters((prev) => {
                if (prev.search === searchText) return prev
                return { ...prev, search: searchText }
            })
        },
        [setFilters],
    )

    return (
        <Grid container gap="1rem" alignItems="center" flexWrap="nowrap">
            <FilterSearch search={filters.search} setSearch={handleSearch} debounceMs={400} />
            {selectedView === ViewType.TIMELINE && (
                <BookPeriodFilter
                    isBookedPeriod={!!filters.isBookedPeriod}
                    setFilters={setFilters}
                    isSpecialFlow={isSpecialFlow}
                />
            )}
            <ResourceFilterMenu
                filters={filters.filters}
                userId={userId}
                setFilters={setFilters}
                isTimeline={isTimeline}
            />
        </Grid>
    )
}
